import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { formatCurrency } from '../utils/currency.utils';
import { Color, CommonProperties, CommonStyles } from '../styles';
import { Modals } from '../constants/ScreenNames';
import Icon from './Icon';
import RowView from './RowView';
import BaseText from './BaseText';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';
import { useSelector } from 'react-redux';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../store/selectors/auth.selector';
const TotalPrice = ({ response, value, navigation, ...rest }) => {
  const { t } = useTranslation(i18nNS.checkout);
  const { tKey } = useComponentTKey('TotalPrice');
  const currency = useSelector(selectCompanyCurrency);
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);

  return (
    <TouchableOpacity
      style={styles.container}
      onPress={() => {
        navigation.navigate(Modals.TripSummaryModal);
      }}
      {...rest}
    >
      <RowView style={styles.container}>
        {response?.IsRedeem ? (
          <>
            <BaseText style={styles.price}>
              {formatCurrency(response.AirResponses[0].TotalTax, currency, currencyCulture)}
            </BaseText>
            <BaseText style={styles.price}>
              {'+'} {response.AirResponses[0].RedeemPoints + ' pts'}
            </BaseText>
            <Icon name="circlePlus" style={styles.icon} />
          </>
        ) : (
          <>
            <BaseText style={styles.price}>
              {formatCurrency(value, currency, currencyCulture)}
            </BaseText>
            <Icon name="circlePlus" style={styles.icon} />
          </>
        )}
      </RowView>
      <BaseText style={CommonStyles.h4}>{t(tKey('ApproxTotal'))}</BaseText>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...CommonProperties.centerAlignment,
    ...CommonProperties.py3,
  },
  price: {
    color: Color.primary,
    ...CommonProperties.h2,
  },
  currency: {
    color: Color.primary,
    alignSelf: 'flex-end',
    ...CommonProperties.body,
    ...CommonProperties.p2,
  },
  icon: {
    color: Color.primary,
    ...CommonProperties.h2,
  },
});

export default TotalPrice;
